import React from 'react'
import { useNavigate } from 'react-router-dom';

const NavBar = (props) =>
  {
    const navigate = useNavigate();

    const handleLogout=()=>{
      localStorage.clear();
      navigate('/login', { replace: true });
    }
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary" data-bs-theme="dark">
  {props.userType==1?<div className="container-fluid">
    <a className="navbar-brand" href="/dashboard">TMS</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        {/* <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="dashboard">Dashboard</a>
        </li> */}

        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="userManagement">User Management</a>
        </li>

        {/* <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Management
          </a>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="/userManagement">User Management</a></li>
            <li><a className="dropdown-item" href="/projectManagement">Project Management</a></li>
            <li><a className="dropdown-item" href="/taskManagement">Task Management</a></li>
            <li><a className="dropdown-item" href="/assignedTaskManagement">Task Assignment</a></li>

          </ul>
        </li> */}
      </ul>
    </div>
  </div>:<div className="container-fluid">
    <a className="navbar-brand" href="/">TMS</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="dashboard">My Task</a>
        </li>

        {/* <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Management
          </a>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="/projectManagement">Project Management</a></li>
            <li><a className="dropdown-item" href="/taskManagement">Task Management</a></li>
            <li><a className="dropdown-item" href="/assignedTaskManagement">Task Assignment</a></li>

          </ul>
        </li> */}
      </ul>
    </div>
  </div>}
  

  {
    localStorage.getItem("id")?
    <div class="ms-auto dropdown me-3">
    <a class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" href="#" id="userDropdown" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="bi bi-person-circle fs-4 me-2"></i>
      <span>{localStorage.getItem("name")}</span>
    </a>
    <ul class="dropdown-menu dropdown-menu-end text-small shadow" aria-labelledby="userDropdown">
      <li class="dropdown-header">
        <strong>{localStorage.getItem("contact")}</strong><br/>
        <small>{localStorage.getItem("Admin")}</small>
      </li>
      <li><hr class="dropdown-divider"/></li>
      <li><a class="dropdown-item" href="#">Profile</a></li>
      <li><a class="dropdown-item text-danger" onClick={handleLogout}>Logout</a></li>
    </ul>
  </div>:
        <li className="nav-item">
          <a className="nav-link" href="login">Login</a>
        </li>
  }

</nav>
    </div>
  )
}

export default NavBar
